"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _RightPanel = _interopRequireDefault(require("@/components/RightPanel"));
var _components = require("./components");
var _ResizeHandler = _interopRequireDefault(require("./mixin/ResizeHandler"));
var _message = _interopRequireDefault(require("./mixin/message"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Layout',
  components: {
    AppMain: _components.AppMain,
    Navbar: _components.Navbar,
    RightPanel: _RightPanel.default,
    Settings: _components.Settings,
    Sidebar: _components.Sidebar,
    TagsView: _components.TagsView
  },
  mixins: [_ResizeHandler.default, _message.default],
  data: function data() {
    return {
      resizeHandler: null
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    showSettings: function showSettings(state) {
      return state.settings.showSettings;
    },
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    },
    fixedHeader: function fixedHeader(state) {
      return state.settings.fixedHeader;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    }
  }),
  mounted: function mounted() {
    // 初始化 CSS 变量
    this.initSidebarWidth();
    // 绑定窗口缩放事件
    this.resizeHandler = this.handleResize;
    window.addEventListener('resize', this.resizeHandler);
    this.handleResize();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    },
    // 初始化侧边栏宽度变量
    initSidebarWidth: function initSidebarWidth() {
      var root = document.documentElement;
      if (!root.style.getPropertyValue('--sideBarWidth')) {
        // 尝试从 Vuex 读取已有宽度，若无则默认 210px
        var defaultWidth = 210;
        if (this.$store.state.app && this.$store.state.app.sidebar && this.$store.state.app.sidebar.width) {
          defaultWidth = parseInt(this.$store.state.app.sidebar.width, 10) || 210;
        }
        root.style.setProperty('--sideBarWidth', "".concat(defaultWidth, "px"));
      }
    },
    // 限制侧边栏宽度，防止超出视口
    limitSidebarWidth: function limitSidebarWidth() {
      var root = document.documentElement;
      var currentWidth = parseFloat(root.style.getPropertyValue('--sideBarWidth')) || 210;
      var maxWidth = window.innerWidth * 0.7;
      var minWidth = 180;
      var newWidth = currentWidth;
      if (currentWidth > maxWidth) newWidth = maxWidth;
      if (currentWidth < minWidth) newWidth = minWidth;
      if (newWidth !== currentWidth) {
        var newWidthStr = "".concat(newWidth, "px");
        root.style.setProperty('--sideBarWidth', newWidthStr);
        // 如果 Vuex 中有存储宽度，也同步更新（可选）
        if (this.$store.state.app && this.$store.state.app.sidebar) {
          this.$store.commit('app/SET_SIDEBAR_WIDTH', newWidthStr);
        }
      }
    },
    // 重置侧边栏位置，避免偏移（轻量级修复）
    resetSidebarPosition: function resetSidebarPosition() {
      var sidebar = document.querySelector('.sidebar-container');
      if (sidebar) {
        // 只移除可能的内联样式，不强制覆盖所有
        sidebar.style.removeProperty('left');
        sidebar.style.removeProperty('transform');
        sidebar.style.removeProperty('margin-left');
      }
    },
    handleResize: function handleResize() {
      this.limitSidebarWidth();
      this.resetSidebarPosition();
    }
  }
};